import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { constants } from '../lib/constants';

export default {
  computed: {
    ...mapState('application', ['isQR']),
    ...mapState('location', { currentLocation: 'current' }),
    ...mapGetters('location', ['findLocation', 'findLocationByUUID', 'getDeliveryMethod']),
    ...mapGetters('user', ['isLoggedIn']),
  },

  watch: {
    async $route(route) {
      if (route.query) {
        if (route.query.u) {
          await this.initUser();
        }
        if (route.query.l) {
          await this.initLocation();
        }

        // Application is marked as QR if the user or location has been set.
        // We then redirect to frontpage to clear the params.
        if (this.isQR && (route.query.u || route.query.l)) {
          await this.$router.replace('/').catch(() => {});
        }
      }
    },

    // Watch if the flag changes and change default delivery method
    async isQR(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === true) {
          const deliveryMethod = this.getDeliveryMethod(3);
          await this.setDefaultDeliveryMethod({ deliveryMethod });
        }
        else {
          await this.setDefaultDeliveryMethod({
            deliveryMethod: this.currentLocation.deliveryMethods[0],
          });
        }
      }
    },
  },

  methods: {
    ...mapActions('user', ['fetchUserByUUID']),
    ...mapMutations('location', ['setCurrentLocation']),
    ...mapMutations('application', ['setAsQR', 'setDefaultDeliveryMethod']),
    ...mapActions('menu', ['initializeRootCategory']),

    async initLocation(defaultLocationId) {
      let location;
      // Load location based on uuid in parameter
      if (this.$route.query.l) {
        location = this.findLocationByUUID(this.$route.query.l);

        if (location) {
          this.$q.cookies.set(
            constants.SESSION_COOKIE_LOCATION_ID,
            this.$route.query.l,
            { expires: '1h' },
          );

          this.setAsQR();
        }
      }

      // Initialize location from cookie if it exists
      else if (this.$q.cookies.has(constants.SESSION_COOKIE_LOCATION_ID)) {
        location = this.findLocationByUUID(
          this.$q.cookies.get(constants.SESSION_COOKIE_LOCATION_ID),
        );
        if (location) {
          this.setAsQR();
        }
      }

      if (!location && defaultLocationId) {
        location = this.findLocation(defaultLocationId);
      }

      await this.setCurrentLocation(location);

      await this.initializeRootCategory({ categoryId: location.categoryId });

      // Set the default delivery method based on the available methods on the location
      if (location.deliveryMethods && location.deliveryMethods.length > 0) {
        if (this.isQR) {
          const deliveryMethod = this.getDeliveryMethod(3);
          await this.setDefaultDeliveryMethod({ deliveryMethod });
        }
        else {
          await this.setDefaultDeliveryMethod({ deliveryMethod: location.deliveryMethods[0] });
        }
      }
    },

    async initUser() {
      // Load user based on uuid in parameter
      if (this.$route.query.u) {
        await this.fetchUserByUUID({ uuid: this.$route.query.u });

        if (this.isLoggedIn) {
          this.$q.cookies.set(
            constants.SESSION_COOKIE_USER_ID,
            this.$route.query.u,
            { expires: '1h' },
          );

          this.setAsQR();
        }
      }

      // Initialize user from cookie if it exists
      else if (this.$q.cookies.has(constants.SESSION_COOKIE_USER_ID)) {
        await this.fetchUserByUUID({
          uuid: this.$q.cookies.get(constants.SESSION_COOKIE_USER_ID),
        });
        if (this.isLoggedIn) {
          this.setAsQR();
        }
      }
    },
  },
};
